'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      duration={3000}
      // Lift toasts above the 64px bottom nav (+ safe area) so they don't cover the tabs.
      offset={80}
      mobileOffset={80}
      // Friendlier defaults: rounded-2xl with subtle honey-tinted border so toasts feel branded.
      toastOptions={{
        classNames: {
          toast: 'rounded-2xl border-[hsl(var(--honey)/0.25)] shadow-md',
          title: 'font-semibold',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
